import { useInstance } from '../../support/ioc/useInstance';
import { HistoryViewModel } from '../../app/HistoryViewModel.ts';
import { Page } from '../../components/page/Page.tsx';
import { usePageView } from '../../support/tracking/usePageView.tsx';
import { HourlyWeatherChart } from './HourlyWeatherChart.tsx';
import { HourlyWeatherChartViewModel } from './HourlyWeatherChartViewModel.ts';
import { useEditableMissionState } from '../../missions/model/useEditableMissionState.tsx';
import { useSubscription } from '@autopylot-internal/state';
import { useUnmount } from '../../support/hooks/useUnmount.tsx';
import { TrackingService } from '../../support/tracking/TrackingService.ts';
import { Refresher } from '../../components/refresher/Refresher.tsx';
import { Logger } from '../../support/debug/Logger.ts';

export const HourlyWeatherChartPage: React.FC<{ missionId: string, disableChartAnimations?: boolean }> = ({ missionId, disableChartAnimations }) => {

    const history = useInstance(HistoryViewModel);
    const tracker = useInstance(TrackingService);
    const log = useInstance(Logger);

    const mission = useEditableMissionState(missionId);

    const chartState = useInstance(HourlyWeatherChartViewModel);
    useSubscription(() => chartState);

    usePageView('Mission Hourly Weather Chart', () => ({
        from: history.getCurrentSearchParams().get('from') || ''
    }));

    useUnmount(() => {
        tracker.track('Weather Chart Closed', chartState.getTrackingMeta);
    });

    if (!mission) {
        return null;
    }

    return (
        <Page title={chartState.getMetricLabel()} onBack={() => history.back(`/missions/${missionId}/weather`)}>

            <Refresher onRefresh={async () => {
                try {
                    await new Promise(res => setTimeout(res, 1000)); // show spinner for 1s
                    await chartState.refresh();
                } catch(err) {
                    log.error(`failed to refresh weather. User will see weather before refresh. ${(err as Error).toString()}`);
                }
            }} />

            <HourlyWeatherChart
                activeTime={history.getCurrentSearchParamMap().startingAt}
                startTime={mission.getStartTime()}
                location={mission.getLocation()}
                link={mission.state.links.weatherForChart}
                disableChartAnimations={disableChartAnimations}
            />

        </Page>
    );
};
